import TyTitle from './TyTitle.vue'
export default TyTitle



// WEBPACK FOOTER //
// ./src/components/ty-title/index.js